import type { ReactNode } from "react";

type ReportBadgeTone = "neutral" | "blue" | "indigo" | "green" | "purple";

const toneClasses: Record<ReportBadgeTone, string> = {
  neutral: "border-gray-200 bg-gray-50 text-gray-600",
  blue: "border-blue-100 bg-blue-50 text-blue-700",
  indigo: "border-indigo-100 bg-indigo-50 text-indigo-700",
  green: "border-green-100 bg-green-50 text-green-700",
  purple: "border-purple-100 bg-purple-50 text-purple-700",
};

interface ReportBadgeProps {
  children: ReactNode;
  tone?: ReportBadgeTone;
}

export default function ReportBadge({ children, tone = "neutral" }: ReportBadgeProps) {
  return (
    <span
      className={`inline-flex min-h-6 items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium leading-none ${toneClasses[tone]}`}
    >
      {children}
    </span>
  );
}
